import LinkCreate from './LinkCreate';
const VideoKeywords = (keyword) => {
  let g = [];

  keyword = keyword.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
  keyword = LinkCreate(keyword, ' ');
  keyword = keyword.split(/\s/g);
  keyword.map((i) => {
    if (i.length > 3) {
      if (
        !(
          i == 'های' ||
          i == 'است' ||
          i == 'هست' ||
          i == 'بود' ||
          i == 'این' ||
          i == 'یکی' ||
          i == 'دادی' ||
          i == 'رفتم' ||
          i == 'ترین' ||
          i == 'دادیش' ||
          i == 'کردم' ||
          i == 'نکن' ||
          i == 'ایی' ||
          i == 'کرده' ||
          i == 'کردن' ||
          i == 'کنم' ||
          i == 'میدم' ||
          i == 'می‌تونی' ||
          i == 'چقده' ||
          i == 'میخوام' ||
          i == 'بیش' ||
          i == 'حال' ||
          i == 'نرفت' ||
          i == 'زدن' ||
          i == 'فقط' ||
          i == 'داد' ||
          i == 'آمدید' ||
          i == 'امدید' ||
          i == 'انقدر' ||
          i == 'رسیدیم' ||
          i == 'چند' ||
          i == 'الان' ||
          i == 'مانده' ||
          i == 'رسید' ||
          i == 'شدی' ||
          i == 'شده' ||
          i == 'اگر' ||
          i == 'مگه' ||
          i == 'نرسید' ||
          i == 'نیست' ||
          i == 'نرسیدیم' ||
          i == 'اگه' ||
          i == 'گردید' ||
          i == 'خواهید' ||
          i == 'نخواهید' ||
          i == 'کسی' ||
          i == 'کرد' ||
          i == 'خواهد'
        )
      ) {
        g.push(i);
      }
    }
  });

  return g;
};
export default VideoKeywords;
